<script>
  import { slide } from "svelte/transition";
  import { ignore } from "../../Common/tools";
  import Checkbox from "../../Common/Checkbox.svelte";
  import TagAndAutoresponderListPicker from "../../Common/TagAndAutoresponderListPicker.svelte";
  import {External, M} from "../../external";

  export let widget,
    onChange = ignore,
    onStructureChange = ignore;

  let data = widget.data,
    widgetUi = widget.$widget;

  let changeButtonStyling = type => {
    let btnData = type === "back" ? data.btnBack : data.btnNext;
    External.Tools.showWindow({
      isModal: false,
      title: M.BUTTON_SETTINGS,
      width: 550,
      forceAtRight: External.showBuilderPopupsOnFullHeight,
      markup: External.ButtonStyleHelper.popupMarkup,
      action: {
        onShow: function(popup, context) {
          External.ButtonStyleHelper.editStyles(popup, context, {
            data: Object.assign({}, btnData),
            changingElement: widgetUi.find(".theme-button"),
            canChangeAlign: false,
            hasFullwidth: false,
            hasPadding: false,
            hasGradient: true,
            onChange: function(btnData) {
              if (type === "next") {
                data.btnNext = btnData;
              } else {
                data.btnBack = btnData;
              }
              onChange();
            }
          });
        }
      }
    });
  };

  let onRenderingChange = () => {
    onChange();
    onStructureChange();
  };
</script>

<div class="popup-widget-wrapper form-admin-style-2">
  <div class="popup-input-wrapper">
    <div class="col20 info">
      <h5>{M.FORM_NAME}</h5>
      <span>{M.FORM_MESSAGE_DASHBOARD}</span>
    </div>
    <input
      type="text"
      class="transition-background"
      bind:value={data.formName}
      on:change={onChange} />
  </div>

  <Checkbox
    bind:data={data.notify}
    label={M.NOTIFY_ON_SUBMIT}
    clz="f20"
    {onChange} />

  {#if data.notify}
    <div
      class="popup-input-wrapper mt-5"
      transition:slide|local={{ duration: 200 }}>
      <h5>{M.SEND_NOTIFICATION_TO}</h5>
      <input
        type="text"
        name="sendTo"
        class="transition-border"
        placeholder={M.EMAIL}
        on:change={onChange}
        bind:value={data.sendTo} />
    </div>
  {/if}

  <div class="col20 f-left">

    <Checkbox
      bind:data={data.autoAdvance}
      clz="f20"
      label="{M.AUTO_ADVANCE}"
      description="{M.AUTO_ADVANCE_DESC}"
      onChange={onRenderingChange} />

    <Checkbox
      bind:data={data.showProgressbar}
      label="{M.SHOW_PROGRESS_BAR}"
      clz="f20"
      onChange={onRenderingChange} />

    <Checkbox
      bind:data={data.showTabs}
      label="{M.SHOW_PROGRESS_TABS}"
      clz="f20"
      onChange={onRenderingChange} />

    <!--
    <Checkbox
      bind:data={data.randomOrder}
      clz="f20"
      label="Random question order"
      description="Show the questions in a random order on the page"
      onChange={onRenderingChange} />
    -->
    <Checkbox
      bind:data={data.showBackBtn}
      label="{M.SHOW_BACK_BUTTON}"
      clz="f20"
      onChange={onRenderingChange} />

    <div class="popup-input-wrapper mt-15 col9">
      <h5>
        {M.NEXT_BUTTON_TEXT}
        <a class="label-link" on:click={() => changeButtonStyling('next')}>
          {M.STYLING}
        </a>
      </h5>
      <input
        type="text"
        class="required transition-all"
        bind:value={data.btnNext.text}
        on:blur={onRenderingChange} />
    </div>

    {#if data.showBackBtn}
      <div
        class="popup-input-wrapper mt-15 col9 f-right"
        transition:slide|local={{ duration: 200 }}>
        <h5>
          {M.BACK_BUTTON_TEXT}
          <a
            class="label-link none"
            on:click={() => changeButtonStyling('back')}>
          {M.STYLING}
          </a>
        </h5>
        <input
          type="text"
          class="required transition-all"
          bind:value={data.btnBack.text}
          on:blur={onRenderingChange} />
      </div>
    {/if}
    <div class="col20 f-left">
      <div class="popup-input-wrapper col9">
        <h5>{M.COMPLETE_BUTTON_TEXT}</h5>
        <input
          type="text"
          class="required transition-all"
          bind:value={data.btnComplete.text}
          on:blur={onRenderingChange} />
      </div>
    </div>
  </div>

  <TagAndAutoresponderListPicker {data} {onChange} label={M.WHEN_FILLED_TITLE} description={M.WHEN_FILLED_DESC} />
</div>
